import { useEffect, useState } from "react";
import { useParams, Link } from "react-router-dom";
import { toast } from "sonner";
import { api, fileUrl } from "@/lib/api";
import { PublicHeader, PublicFooter } from "@/components/PublicChrome";
import { useCart } from "@/context/CartContext";

export default function ProductDetail() {
    const { id } = useParams();
    const [p, setP] = useState(null);
    const [notFound, setNotFound] = useState(false);
    const { add } = useCart();

    useEffect(() => {
        (async () => {
            try {
                const { data } = await api.get(`/public/products/${id}`);
                setP(data);
            } catch { setNotFound(true); }
        })();
    }, [id]);

    if (notFound) return (
        <div className="min-h-screen">
            <PublicHeader />
            <div className="max-w-3xl mx-auto px-4 py-24 text-center">
                <div className="font-mono text-xs uppercase tracking-widest text-neutral-400">404</div>
                <h1 className="mt-2 font-heading font-black text-3xl">Produto não encontrado</h1>
                <Link to="/produtos" className="mt-6 inline-block text-brand-blue underline">← Voltar ao catálogo</Link>
            </div>
        </div>
    );

    if (!p) return <div className="min-h-screen grid place-items-center font-mono text-sm text-neutral-500">carregando…</div>;

    const specs = p.specs || {};

    return (
        <div className="min-h-screen">
            <PublicHeader />
            <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-10">
                <div className="text-xs font-mono uppercase tracking-widest text-neutral-500 mb-6">
                    <Link data-testid="breadcrumb-catalog" to="/produtos" className="hover:text-brand-blue">catálogo</Link>
                    <span className="mx-2">/</span>
                    <span>{p.brand?.name}</span>
                    <span className="mx-2">/</span>
                    <span className="text-neutral-900">{p.name}</span>
                </div>

                <div className="grid lg:grid-cols-2 gap-8">
                    <div className="border border-neutral-300 bg-white aspect-square overflow-hidden">
                        {p.image_url ? (
                            <img src={fileUrl(p.image_url)} alt={p.name} className="w-full h-full object-cover" />
                        ) : (
                            <div className="w-full h-full grid place-items-center font-mono text-sm text-neutral-400">sem imagem</div>
                        )}
                    </div>
                    <div>
                        <div className="text-xs font-mono uppercase tracking-widest text-brand-blue">{p.brand?.name} · {p.category?.name}</div>
                        <h1 data-testid="product-title" className="mt-2 font-heading font-black text-4xl tracking-tight">{p.name}</h1>
                        {p.sku && <div className="mt-2 font-mono text-sm text-neutral-500">SKU · {p.sku}</div>}
                        {p.description && <p className="mt-6 text-neutral-700 leading-relaxed">{p.description}</p>}

                        {Object.keys(specs).length > 0 && (
                            <div className="mt-8 border border-neutral-300 bg-white">
                                <div className="p-4 border-b border-neutral-200 font-mono text-xs uppercase tracking-widest text-neutral-500">Especificações Técnicas</div>
                                <table className="w-full font-mono text-sm">
                                    <tbody>
                                        {Object.entries(specs).map(([k, v], idx) => (
                                            <tr key={k} className={idx % 2 ? "bg-neutral-50" : ""}>
                                                <td className="px-4 py-3 text-neutral-500 uppercase text-xs tracking-wider border-r border-neutral-200 w-1/2">{k}</td>
                                                <td className="px-4 py-3 text-neutral-900">{String(v)}</td>
                                            </tr>
                                        ))}
                                    </tbody>
                                </table>
                            </div>
                        )}

                        <div className="mt-8 border border-dashed border-neutral-300 p-6 bg-white flex items-center justify-between gap-4">
                            <div>
                                <div className="font-mono text-xs uppercase tracking-widest text-brand-blue mb-1">Interessado?</div>
                                <div className="text-neutral-700">Adicione à lista e envie ao vendedor via WhatsApp/e-mail.</div>
                            </div>
                            <button data-testid="detail-add-to-list" onClick={() => { add(p); toast.success("Adicionado à lista"); }} className="h-12 px-6 bg-brand-blue text-white font-heading font-bold uppercase tracking-wider text-sm hover:bg-brand-blue-hover flex items-center gap-2">
                                Adicionar à Lista
                            </button>
                        </div>
                    </div>
                </div>
            </div>
            <PublicFooter />
        </div>
    );
}
